import { useEffect, type FC, useCallback, memo } from 'react';

import * as ModalWindows from '@Stores/ModalWindows';
import useNavigation from '@Navigation/useNavigation';

export const SuccessSubscribeModalLoader: FC = () => {
  const location = useNavigation();

  const handleModalOpen = useCallback(() => {
    ModalWindows.open('SuccessEmailConfirmed');
  }, []);

  useEffect(() => {
    if (location.search.includes('promo=success&direct-crm-ticket=')) {
      setTimeout(handleModalOpen, 200);
    }
  }, [handleModalOpen, location.search]);

  return null;
};

export default memo(SuccessSubscribeModalLoader);
